// About.js
import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function EcnPage() {
  useEffect(() => {
    document.title = 'FAMA - ECN';
  }, []);
  return (
    <Container className='public-page-container'>
      <Row>
        <h1>Equipo Coordinador Nacional</h1>
      </Row>
      <Row>
        <Col>
          <img src='/fama-ecn.jpeg' alt='Equipo Coordinador Nacional de FAMA' />
        </Col>
      </Row>
    </Container>
  );
}

export default EcnPage;
